import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const usePollSubmissionPost = () => {
  const pollSubmission = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v3/activity/interaction/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(pollSubmission);
};

export default usePollSubmissionPost;
